import { matchCodeUrl } from '@/constants/urls';
import searchTabTemplate from './searchTabTemplate';

export default {
  ...searchTabTemplate(matchCodeUrl(['search']), ({ search }) => search.run),
  componentState: ({ args, props }) => {
    props.search({ query: args.pop() });
    return { category: 'open', url: encodeURI(`/${args.join('/')}`) };
  },
};
